@import '../../css/typography-helpers';

:host {
  display: block;
}

@mixin colorVariant($variant) {
  --md-sys-color-primary: var(--md-sys-color-#{$variant});
  --md-sys-color-on-primary: var(--md-sys-color-on-#{$variant});
  --md-sys-color-primary-container: var(--md-sys-color-#{$variant}-container);
  --md-sys-color-on-primary-container: var(--md-sys-color-on-#{$variant}-container);
  & * {
    --_outline-color: var(--md-sys-color-#{$variant});
  }
}

$variants: (
  'primary': 'purple',
  'secondary': 'green',
  'tertiary': 'orange',
  'black': 'black',
);

@each $variant, $alias in $variants {
  :host([color='#{$variant}']) {
    @include colorVariant($variant);
  }

  :host-context(.#{$alias}):host([color='primary']) {
    @include colorVariant($variant);
  }
  :host-context(.#{$alias}):host([color='secondary']) {
    @include colorVariant($variant);
  }
  :host-context(.#{$alias}):host([color='tertiary']) {
    @include colorVariant($variant);
  }
  :host-context(.#{$alias}):host([color='black']) {
    @include colorVariant($variant);
  }
}

:host([size='l']) *,
:host([size='large']) * {
  --_container-height: 56px;
  @extend .label-large;
}

:host([size='medium']) *,
:host([size='medium']) * {
  --_container-height: 46px;
  @extend .label-medium;
}

:host([size='small']) * {
  --_container-height: 36px;
  @extend .label-small;
}
